
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IMockHero } from '@/constants/monitor-mock'

@Component({ name: 'DashboardHero' })
export default class DashboardHero extends Vue {
    @Prop({ required: true }) private hero!: IMockHero
}
